<template>
    <vue-google-autocomplete
      :id="id"
      :name="name"
      classname="form-control"
      placeholder=""
      v-on:placechanged="getAddressData"
      :value="street"
      :country="countryList"
    >
    </vue-google-autocomplete>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import {getField} from "./utils/index.js";
var fieldTerms = require('@/assets/fields.json');

export default {
  name: 'app',
  components: {
    VueGoogleAutocomplete
  },
  data: function () {
    return {
      street: '',
      city: '',
      state: '', 
      country: '',
      postal: ''
    }
  },
  methods: {
    getAddressData: function (addressData, result, id) {
      console.log(addressData);
      console.log(result);

      //Get Fields
      var street = getField(this.formElements, fieldTerms.street.include, fieldTerms.street.exclude);
      var city = getField(this.formElements, fieldTerms.city.include, fieldTerms.city.exclude);
      var state = getField(this.formElements, fieldTerms.state.include, fieldTerms.state.exclude);
      var country = getField(this.formElements, fieldTerms.country.include, fieldTerms.country.exclude);
      var postal = getField(this.formElements, fieldTerms.postal.include, fieldTerms.postal.exclude);

      //Get City and Postal
      city.value = (!!addressData.locality) ? addressData.locality : '';
      postal.value = (!!addressData.postal_code) ? addressData.postal_code : '';

      //Look Up Country to get shortname as value
      var c = result.address_components.filter(function(r){
        return r.long_name === addressData.country;
      });

      var selectedState = '';

      if(c.length>0){
        if(!!c[0].short_name){
          if(fieldTerms.usTerritories.indexOf(c[0].short_name) > -1){
            // If country is a US Territory set the country code as state
            selectedState = c[0].short_name;
            c[0].short_name = "US";
          }else{
            // Otherwise, set the state using addressData 
            selectedState = addressData.administrative_area_level_1;
          }
          country.value = c[0].short_name;
        }
      }

      //For address get item clicked bc street # is sometimes not in addressData. Also, countries with states or provinces are formatted different.
      var fullAddress = street.value.split(',');
      console.log(selectedState);
      if(fieldTerms.countriesWithStatesProvinces.indexOf(country.value) > -1){
        street.value = fullAddress[0];
      }else{
        street.value = fullAddress[0] + ', '+ fullAddress[1];
      }

      state.value = selectedState;
      //Check state once more to account for delay in Dyna Country
      if(state.value == ''){
        setTimeout(function(){state.value = selectedState;}, 1000);
      }
    },

  },
  computed: {
    id: function(){
      return this.$parent.id
    },
    name: function(){
      return this.$parent.name
    },
    formElements: function(){
      return this.$parent.formElements
    },
    countryList: function(){
      return [];
    }
  }
};
</script>

<style>
.pac-container{
  min-width: 300px !important;
}
</style>
